import { render, staticRenderFns } from "./MaterialStreamLoader.vue?vue&type=template&id=6549bd52&scoped=true"
import script from "./MaterialStreamLoader.vue?vue&type=script&lang=js"
export * from "./MaterialStreamLoader.vue?vue&type=script&lang=js"
import style0 from "./MaterialStreamLoader.vue?vue&type=style&index=0&id=6549bd52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6549bd52",
  null
  
)

export default component.exports